// The close: what you still need to do.
//
// Reworded on the advisor lead's instruction, and the instruction is the whole
// sales method: "our whole way we present... it's always about here's what you
// need to do. We don't talk at all about how we can help. And at the end it's
// just: what questions do you have?" So this page never pitches. It lists the
// decisions, each tied to a number from earlier, chunked the way a person can
// actually absorb them: now, next, later. That framing came from a Northwestern
// Mutual deliverable an advisor rated better than ours, and he was right.

const PHASES = [
  { key: 'now', title: 'Now', note: 'worth acting on this year' },
  { key: 'next', title: 'Next', note: 'decisions with a window' },
  { key: 'later', title: 'Later', note: 'standing questions to keep answered' },
];

export default function NextStepsSection({ questions }) {
  if (!questions?.length) return null;
  const groups = PHASES
    .map(p => ({ ...p, items: questions.filter(q => (q.phase || 'later') === p.key) }))
    .filter(g => g.items.length);

  return (
    <section className="asmt-card asmt-next" id="next-steps">
      <div className="asmt-card-head">
        <h2>What you still need to do</h2>
      </div>
      <p className="asmt-lede">
        Everything above shows where you stand. These are the decisions it puts in
        front of you, in the order they deserve attention. Each one depends on tax
        projections and return assumptions this document deliberately does not make.
      </p>
      {groups.map(g => (
        <div className="asmt-next-phase" key={g.key}>
          <h3 className="asmt-next-phasehead">
            {g.title} <span className="asmt-next-phasenote">{g.note}</span>
          </h3>
          <ol className="asmt-next-list">
            {g.items.map(q => (
              <li className="asmt-next-item" key={q.key}>
                <div className="asmt-next-q">{q.question}</div>
                <p className="asmt-next-because">{q.because}</p>
              </li>
            ))}
          </ol>
        </div>
      ))}
    </section>
  );
}
